import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import "./style.css";
import axios from 'axios';

export const Leaderboard = () => {
  const navigate = useNavigate();
  const [investors, setInvestors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${apiUrl}/Ecovest/nbrtrees`);
        if (response.data.status.code === 1) {
          // The data is nested in response.data.data[0] based on your API response
          setInvestors(response.data.data[0]);
        } else {
          setError(response.data.status.message);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="leaderboard d-flex justify-content-center px-3">
      <div className="leaderboard-container div d-flex flex-column justify-content-center align-items-start my-4">
        <div className="d-flex flex-column justify-content-center align-items-start w-100">
          <div className="d-flex flex-row justify-content-between align-items-start w-100">
            <div className="d-flex gap-3 align-items-start w-100">
              <h1 className="text-start title-text">LEADERBOARD</h1>
              <img src="/assets/images/ecovestonboarding/rocket.png" alt="leaderboard" className="img-fluid" />
            </div>
            <button className="button" onClick={() => navigate(-1)}>
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>
          <p className="text-start description-text">Most planted trees</p>
        </div>

        {/* Render investors dynamically */}
        {investors.map((investor, index) => {
          // Determine styling based on position
          let containerClass = "other-investor";
          let imageClass = "image-other-investor";
          let numberClass = "number-trees-other-investor";
          let textClass = "text-number-trees-other";
          
          if (index === 0) {
            containerClass = "first-investor";
            imageClass = "image-first-investor";
            numberClass = "number-trees-first-investor";
            textClass = "text-number-trees";
          } else if (index === 1) {
            containerClass = "second-investor";
            imageClass = "image-second-investor";
            numberClass = "number-trees-second-investor";
            textClass = "text-number-trees";
          } else if (index === 2) {
            containerClass = "third-investor";
            imageClass = "image-third-investor";
            numberClass = "number-trees-third-investor";
            textClass = "text-number-trees";
          }

          return (
            <div key={investor.investorId} className={`d-flex align-items-start w-100 gap-3 mt-3 py-2 px-4 ${containerClass}`}>
              <div className={`${imageClass} d-flex flex-column justify-content-center align-items-center my-auto`}>
                {index === 0 && <i className="fa-solid fa-crown crown-first-investor"></i>}
                <img src="/assets/images/favicon.png" alt="profile" className="profile-image"/>
                {index < 3 && (
                  <div className="d-flex">
                    <p className="text-rate">{index + 1}</p>
                    <i className={`fa-solid fa-square ${index === 0 ? 'square-first-investor' : index === 1 ? 'square-second-investor' : 'square-third-investor'}`}></i>
                  </div>
                )}
              </div>
              <div className="d-flex flex-lg-row flex-md-row flex-column-reverse justify-content-center align-items-start w-100">
                <div className="d-flex flex-column justify-content-center align-items-start w-100 py-3">
                  <h2 className="text-start name-investor m-0">{investor.firstName} {investor.lastName}</h2>
                  <h3 className="text-start description-investor m-0">One tree can make a forest.</h3>
                </div>
                <div className="d-flex flex-column justify-content-end align-items-end w-100 py-3">
                  <div className={`${numberClass} px-2 py-0`}>
                    <h2 className={`text-start ${textClass} p-2 m-0`}>{investor.numberOfTrees} tree{investor.numberOfTrees !== 1 ? 's' : ''}</h2>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Leaderboard;